import { renderInfoValue } from 'utils/helpers';
import ActionWidget, { ActionWidgetSkeleton } from './ActionWidget';
import { PackageCountWidgetProps } from './PackageCount';
import { Flex, Typography } from 'antd';

interface SignedInvoicesWidgetProps extends PackageCountWidgetProps {
  title: React.ReactNode;
  ctaContent: React.ReactNode;
  onCtaClick?: () => void;
}

const { Text } = Typography;

const SignedInvoicesWidget = ({
  shipped,
  delivered,
  invoiceUploaded: packagesWithSignedInvoices,
  isLoading,
  onCtaClick,
  ctaContent,
  title,
}: SignedInvoicesWidgetProps) => {
  const totalPackages = (shipped || 0) + (delivered || 0);
  const percent = Math.round(
    ((packagesWithSignedInvoices || 0) / totalPackages) * 100,
  );

  if (isLoading) return <ActionWidgetSkeleton />;
  return (
    <ActionWidget
      title={title}
      data={
        <Flex vertical gap={5} className="mt-1">
          {renderInfoValue(`${percent || 0}%`, 'N/A')}
          <Text type="secondary">
            {renderInfoValue(packagesWithSignedInvoices || 0, 'N/A')} out of{' '}
            {totalPackages || 0}
          </Text>
        </Flex>
      }
      ctaContent={ctaContent}
      onCtaClick={onCtaClick}
    />
  );
};

export default SignedInvoicesWidget;
